<script>
    import ModalTitle from "./Modal/ModalTitle.svelte";
    import ModalButtons from "./Modal/ModalButtons.svelte";
    import dbData from "../Stores/utilityDBStore.js";
    import { fetchCurrentAuthToken, formRequestAction } from "../scripts/awsUtils.js";

    let txtSubject;
    let txtMessage;

    function sendHelpRequest() {
        let helpRequest = {};
        helpRequest['subject'] = txtSubject.value;
        helpRequest['message'] = txtMessage.value;
        console.log("Help request: ", helpRequest);
        try {
            let promise = new Promise(fetchCurrentAuthToken);
            promise.then((authToken) => {
                sendMessage(authToken, helpRequest);
            });
        } catch (error) {
            alert("An error has occurred, please check internet connection and try again.");
            console.log(error);
        }
        return;
    }

    async function sendMessage(authToken, helpRequest) {
        try {
            const ra = formRequestAction("message", { wpn_id: $dbData.wpn_id, message_data: helpRequest }, authToken);
            const resSendMsg = await fetch(ra.url, ra.initData);
            if (resSendMsg.ok) {
                alert("Success: Your support request has been sent via email.");
            }
            else {
                alert("Error: Support request was not successful, check internet connection and try again.");
            }
        } catch(error) {
            console.error('Error sending Message request: ', error);
        }
    }

</script>

<!-- https://developer.mozilla.org/en-US/docs/Learn/Forms/Your_first_form -->
<!-- https://github.com/coderschool/simple-svelte-contact-form/blob/master/src/App.svelte -->
<div>
    <ModalTitle title="64seconds Support Center" on:close />
</div>
<div class="help-container">
    <div class="support-request-container">
        <div class="help-request-banner">
            <img
                class="company-logo"
                src="/images/64sLogo.png"
                alt="Item logo"
            />
            <h2>Support Request</h2>
        </div>
        <div class="help-request-message">
            <h4>Open a Help Ticket</h4>
            <p id="by-line">Send us a message and we'll reply by email.</p>
            <fieldset>
                <label for="help-subject">Subject</label>
                <input
                    type="text"
                    name="help-subject"
                    bind:this={txtSubject}
                />
            </fieldset>
            <fieldset>
                <label for="help-message">Please Enter Your Question</label>
                <textarea
                    name="help-message"
                    bind:this={txtMessage}
                    style="height:200px"
                />
            </fieldset>
        </div>
    </div>
    <footer>
        <slot name="footer">
            <ModalButtons
                actions={["close", "send"]}
                on:close
                on:send={sendHelpRequest}
            />
        </slot>
    </footer>    
</div>

<style>
    .help-container {
        display: flex;
        flex-direction: column;
        min-height: 100vh; /* Make sure it takes the full viewport height */
    }
    .support-request-container {
        flex: 0.6;
        height: 32vh;
    }
    fieldset {
        padding: 10px 0;
        border: none;
        width: 64%;
        text-align: center;
        margin: auto;
    }
    .help-request-banner {
        display: flex;
        align-items: center;
        padding: 1rem;
        justify-content: center;
    }
    .company-logo {
        width: 30%;
        height: auto;
    }
    h2 {
        font-weight: 300;
        font-size: xx-large;
        color: rgb(67, 148, 11);
        padding-left: 20px;
        padding-bottom: 8px;
        text-align: center;
    }
    h4 {
        color: #0A6EBD;
        font-weight: 400;
        font-size: larger;
        margin: auto;
    }
    .help-request-message {
        width: 80%;
        margin: 16px auto;
        text-align: center;
        background-color: #f7f7f7;
        border-radius: 16px;
        padding: 16px 0 24px 0;
    }
    #by-line {
        margin-bottom: 32px;
    }
    input[type="text"],
    textarea {
        width: 100%;
        border: 1px solid #ccc;
        box-sizing: border-box;
        margin-bottom: 16px;
        resize: vertical;
    }
</style>
